import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  ValidationErrors,
} from '@angular/forms';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { SignupService } from '../auth/services/signup.service';

@Injectable({
  providedIn: 'root',
})
export class UserNameValidator implements AsyncValidator {
  constructor(private signupService: SignupService) {}
  validate = (control: AbstractControl) => {
    const { value } = control;
    const error: ValidationErrors = { newUserNameIncludesPlusSign: true };
    return this.signupService.checkExistUser(value).pipe(
      take(1),
      map((response) => {
        if (!response.Exists && value.includes('+')) {
          return error;
        }

        return null;
      }),
      catchError((err) => {
        return of(err);
      })
    );
  };
}
